import { useApiQuery } from "@/api";
import { getCompany } from "@/entities/Company";
import { useEffect, useState } from "react";

export function useLogoUrl() {
    const company = useApiQuery(getCompany);
    const domain = company.data?.website?.split("//")[1];
    const [logoUrl, setLogoUrl] = useState<string | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!domain) {
            setLogoUrl(undefined);
            return;
        }

        const url = `https://cdn.brandfetch.io/${domain}?c=1id_c-RSkEnaPP4iucC`;
        setIsLoading(true);

        const testImg = new Image();

        testImg.onload = () => {
            if (testImg.naturalWidth > 0 && testImg.naturalHeight > 0) {
                setLogoUrl(url);
            } else {
                setLogoUrl(undefined);
            }
            setIsLoading(false);
        };

        testImg.onerror = () => {
            setLogoUrl(undefined);
            setIsLoading(false);
        };

        testImg.src = url;

        return () => {
            testImg.onload = null;
            testImg.onerror = null;
        };
    }, [domain]);

    return { logoUrl, isLoading, notFound: !logoUrl && !isLoading };
}
